import React from 'react';
import { CircularTimer } from './CircularTimer';
import { useSelector } from 'react-redux';
import { calculateTime } from 'src/helpers/timeHelper';
import { getDriverConfig, getRuleset } from 'src/features/profile/store';
import { getRegulationsFromRuleset } from 'src/helpers/firestoreDriverHelpers';
import { getCycleData } from 'src/helpers/driverEldInfoHelper';

import './circularTimer.scss';
import './timersContainer.scss';
import { RULESET_NAMES } from 'src/constants/ELDConstants';

interface Props {
  isMobile: boolean;
}
export const TimersContainer: React.FC<Props> = ({ isMobile }) => {
  const ruleset = useSelector(getRuleset);
  const regulations = ruleset ? getRegulationsFromRuleset(ruleset) : [];
  const size = isMobile ? 120 : 150;
  const strokeWidth = isMobile ? 5 : 8;

  let cycleWorkedTimer = 0;
  let cycleTomorrowTimer = 0;
  let cycleTimer = 0;
  let cyclePercentage = 0;
  const cycleRegulation = ruleset?.cycleRegulations?.find(reg => reg.id === 'CYCLE');

  const driverConfig = useSelector(getDriverConfig);

  if (cycleRegulation) {
    const cycleTimers = getCycleData(cycleRegulation);
    cycleWorkedTimer = cycleTimers.cycleWorkedTimer;
    cycleTomorrowTimer = cycleTimers.cycleTomorrowTimer ?? 0;
    cycleTimer = cycleTimers.cycleTimer ?? 0;
    cyclePercentage = cycleTimers.cycleTimerPercentage ?? 0;
  }

  return (
    <div className="timers-container">
      <div className="timers-container-text">
        <p>{RULESET_NAMES[driverConfig.activeRuleset]}</p>
      </div>
      <div className="timers-container-timers">
        {regulations?.length > 0 &&
          regulations.map(reg => (
            <CircularTimer
              key={reg.text}
              percentage={reg.percentage}
              strokeWidth={strokeWidth}
              size={size}
              text={calculateTime(reg.time, true)}
              subText={reg.text}
            />
          ))}
        {ruleset?.cycleRegulations && (
          <CircularTimer
            percentage={cyclePercentage}
            strokeWidth={strokeWidth}
            size={size}
            text={calculateTime(cycleTimer, true)}
            subText="Cycle"
          />
        )}
      </div>
      <div className="timers-container-text">
        <p>Cycle Worked {calculateTime(cycleWorkedTimer, true)}</p>
        <p>Cycle Tomorrow {calculateTime(cycleTomorrowTimer, true)}</p>
      </div>
    </div>
  );
};
